export const formatFileSize = (bytes) => {
  if (!bytes) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export const buildRequestErrorMessage = (prefix, error) => {
  let message = prefix;
  if (error?.response) {
    message += `: ${error.response.data?.message || error.response.statusText || '请求失败'}`;
  } else if (error?.request) {
    message += ': 服务器无响应';
  } else {
    message += `: ${error?.message || '未知错误'}`;
  }
  return message;
};

export const isWindowsAbsolutePath = (path) => /^[a-zA-Z]:\\/.test(path || '');

export const getPathFileName = (path) => {
  if (!path) return '';
  const parts = String(path).split(/[\\/]/);
  return parts[parts.length - 1] || '';
};
